import { BlockInstanceProps } from '../Block';
import ProfileGrid from '../../components/ProfileGrid';
import {
  BackgroundColorEnum,
  ContentTypeEnum,
} from '../../constants/cms-constants';
import {
  ComponentWithControlOptions,
  ControlOption,
} from '../../utils/controlOptions/ControlOptionDecorator';
import controlOptionDefinitions from '../../utils/controlOptions/controlOptionDefinitions';

@ControlOption([
  {
    key: 'backgroundColor',
    definition: controlOptionDefinitions.backgroundColor,
  },
  {
    key: 'profileGridType',
    definition: controlOptionDefinitions.profileGridTypes,
  },
  {
    key: 'seoWeight',
    definition: controlOptionDefinitions.SEOWeightTypes,
  },
])
class ProfileGridBlock extends ComponentWithControlOptions<BlockInstanceProps> {
  static profileGridTypes = ProfileGrid.profileGridTypes;

  render() {
    const { block, blockContent } = this.props;
    const controlOptions = block?.controlOptionsV2;
    const backgroundColor =
      BackgroundColorEnum[controlOptions?.backgroundColor];
    const profileGridType = controlOptions?.profileGridType;
    const seoWeight = controlOptions?.seoWeight;
    let persons;
    blockContent.doQuery((content) => {
      persons = content.getAllOfType(ContentTypeEnum.PERSON);
    });

    return (
      <ProfileGrid
        persons={persons}
        backgroundColor={backgroundColor}
        profileGridType={profileGridType}
        seoWeight={seoWeight}
      />
    );
  }
}

export default ProfileGridBlock;
